import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import MiniLoader from './miniLoader';
import Ending from './ending';
let scrollPos = 0;
const MenuList = _ref => {
  let children = _ref.children,
    _ref$pageNext = _ref.pageNext,
    pageNext = _ref$pageNext === void 0 ? null : _ref$pageNext,
    _ref$hasNext = _ref.hasNext,
    hasNext = _ref$hasNext === void 0 ? false : _ref$hasNext,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$endMessage = _ref.endMessage,
    endMessage = _ref$endMessage === void 0 ? null : _ref$endMessage;
  const onScroll = event => {
    const newPos = event.target.scrollTop;
    if (newPos !== 0) {
      scrollPos = newPos;
    }
  };
  const hasMore = pageNext && hasNext;
  const ending = /*#__PURE__*/React.createElement(Ending, {
    endingMessage: endMessage,
    isLoading: isLoading
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "scroll-target",
    className: "t-select-menulist-container",
    style: {
      maxHeight: '300px',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: children.length || 0,
    next: pageNext,
    scrollableTarget: "scroll-target",
    style: {
      overflow: 'hidden'
    },
    initialScrollY: scrollPos,
    hasMore: hasMore,
    loader: /*#__PURE__*/React.createElement(MiniLoader, null),
    onScroll: onScroll,
    endMessage: ending
  }, children));
};
MenuList.propTypes = {
  children: PropTypes.node.isRequired,
  pageNext: PropTypes.func,
  isLoading: PropTypes.bool,
  hasNext: PropTypes.bool,
  endMessage: PropTypes.string
};
export default MenuList;